import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivityService } from '@app/core/services/activity.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as _ from 'lodash';

@Component({
  selector: 'app-logs-detail',
  templateUrl: './logs-detail.component.html',
  styleUrls: ['./logs-detail.component.scss']
})
export class LogsDetailComponent implements OnInit, OnDestroy {

  activityId: number;
  activityDetail: any;
  protected unsubscribe$: Subject<boolean> = new Subject<boolean>();

  constructor(
    @Inject(MAT_DIALOG_DATA) data,
    private dialogRef: MatDialogRef<LogsDetailComponent>,
    private activityService: ActivityService) {
    this.activityId = data.ActivityId;
  }

  ngOnInit(): void {
    this.activityService.getActivityDetail(this.activityId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((detail: any) => this.activityDetail = detail);
  }

  getRelatedGroup(relatedItemName: string, operationType: number): any[] {
    var relatedItems = _.find(this.activityDetail.RelatedItems, r => r.Name === relatedItemName)?.Properties;
    return _.filter(relatedItems, i => i.OperationType == operationType)
  }

  close() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.unsubscribe$.next(true);
  }
}
